import BaseStore from '@/store/base-store'

const options = {}
export default new BaseStore('campaign-comments', options)



// WEBPACK FOOTER //
// ./src/store/modules/campaign-comments.store.js